import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../Redux/Store';
import { callClerk } from '../Redux/Public/orderApi';

interface UseClerkCallProps {
  activeStoreId: string;
  activeDiningTableId: string;
}

export const useClerkCall = ({ activeStoreId, activeDiningTableId }: UseClerkCallProps) => {
  const dispatch = useDispatch<AppDispatch>();
  const [showCallClerkConfirm, setShowCallClerkConfirm] = useState(false);

  const handleCallClerk = () => {
    setShowCallClerkConfirm(true);
  };

  const handleConfirmCallClerk = () => {
    if (activeStoreId && activeDiningTableId) {
      dispatch(callClerk({
        activeStoreId,
        activeDiningTableId,
      }));
      setShowCallClerkConfirm(false);
    }
  };

  return {
    showCallClerkConfirm,
    setShowCallClerkConfirm,
    handleCallClerk,
    handleConfirmCallClerk,
  };
};